import { NavigationGuard } from "vue-router"
import { useUserStore } from "@/store/user-store"
import { useEnrollmentStore } from "@/store/enrollment-store"

export const benefitsEnrollmentLoginGuard: NavigationGuard = (to, from, next) => {
  if (!useUserStore().isLoggedIn) {
    return next()
  }

  const enrollmentStore = useEnrollmentStore()
  enrollmentStore.loadPendingEnrollments().then()
  if (enrollmentStore.pendingEnrollments.length > 0) {
    return next({ name: "enroll-setup" })
  } else if (enrollmentStore.pendingCompanyYouthMembershipPlanEnrollments.length > 0) {
    return next({ name: "youth-membership-enroll-setup" })
  } else {
    return next({ name: "home" })
  }
}

export const benefitsEnrollmentGuard: NavigationGuard = (to, from, next) => {
  if (!useUserStore().isLoggedIn) {
    return next({ name: "enroll" })
  }

  const enrollmentStore = useEnrollmentStore()
  enrollmentStore.loadPendingEnrollments().then()
  const hasPendingBenefitEnrollments: boolean = enrollmentStore.pendingEnrollments.length >= 0
  if (!hasPendingBenefitEnrollments) {
    return next({ name: "home" })
  }

  return next()
}

export const youthBenefitsEnrollmentGuard: NavigationGuard = (to, from, next) => {
  if (!useUserStore().isLoggedIn) {
    return next({ name: "enroll" })
  }

  const enrollmentStore = useEnrollmentStore()
  enrollmentStore.loadPendingEnrollments().then()
  const hasPendingYouthMembershipPlanEnrollments: boolean =
    enrollmentStore.pendingCompanyYouthMembershipPlanEnrollments.length >= 0

  if (!hasPendingYouthMembershipPlanEnrollments) {
    return next({ name: "home" })
  }

  return next()
}
